'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { OutcomeIdentityImage } from '@/components/market/identity/outcome-identity-image';
import { useMarketOutcomeColor } from '@/hooks/chart/use-outcome-color';
import { SettledSeal } from './settled-seal';
interface WinnerIdentityHeaderProps {
  marketPubkey: string;
  outcomeIndex: number;
  name: string;
  imageUrl: string | null;
  imageNsfw: boolean;
  imageAlt: string;
  status: ReactNode;
  showSettledBadge?: boolean;
}

/** Shared winning-token identity for the trade card and Winner tab. */
export function WinnerIdentityHeader(t0) {
  const $ = _c(22);
  const {
    marketPubkey,
    outcomeIndex,
    name,
    imageUrl,
    imageNsfw,
    imageAlt,
    status,
    showSettledBadge: t1
  } = t0;
  const showSettledBadge = t1 === undefined ? false : t1;
  const {
    hue
  } = useMarketOutcomeColor(marketPubkey, outcomeIndex);
  const t2 = imageUrl !== null && imageUrl !== "" ? imageUrl : null;
  let t3;
  if ($[0] !== hue || $[1] !== imageNsfw || $[2] !== marketPubkey || $[3] !== outcomeIndex || $[4] !== t2) {
    t3 = {
      kind: "outcome",
      marketPubkey,
      outcomeIndex,
      hue,
      imageUrl: t2,
      nsfw: imageNsfw
    };
    $[0] = hue;
    $[1] = imageNsfw;
    $[2] = marketPubkey;
    $[3] = outcomeIndex;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== imageAlt || $[7] !== t3) {
    t4 = <OutcomeIdentityImage variant="thumbnail" entity={t3} alt={imageAlt} size="size-14" rounded="rounded-control" preview={false} />;
    $[6] = imageAlt;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== showSettledBadge) {
    t5 = showSettledBadge && <SettledSeal className="pointer-events-none absolute -bottom-2.5 -right-2.5 z-10 size-9" />;
    $[9] = showSettledBadge;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <div className="relative shrink-0">{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== name) {
    t7 = <span className="truncate text-heading text-foreground-primary">{name}</span>;
    $[14] = name;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== status || $[17] !== t7) {
    t8 = <div className="flex min-w-0 flex-col gap-1">{t7}{status}</div>;
    $[16] = status;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t6 || $[20] !== t8) {
    t9 = <div className="flex items-center gap-4">{t6}{t8}</div>;
    $[19] = t6;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}